export const countLoginBackgroundDefault = 1
export const countLoginBackgroundSpecial = 2
export const countBannerHome = 1